'use client'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/wallet/wallet-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import { GO_TO_WALLET_URL } from '../../constants/routes'

const GoToWallet = ({ primary, title, inverse, theme, size }: ConversationActionProps) => {
  const { transaction } = useConversationContext()
  const { track } = useTracking()

  const trackButtonClick = () => {
    track(
      clickEvent({
        target: 'go_to_my_balance',
        targetDetails: transaction?.id.toString(),
      }),
    )
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={GO_TO_WALLET_URL}
      onClick={trackButtonClick}
    />
  )
}

export default GoToWallet
